$(document).ready(function () {

    var collapsibleContentComponent = $("body:not(.website-state-edit) .module-agenda-accordion-content");

    if (collapsibleContentComponent.length > 0) {

        collapsibleContentComponent.hide();

        //WRAP CONTENT BETWEEN H2 HEADINGS IN DIVS
        $(".module-agenda-sheet-item-clickable-container").each(function () {
            $(this).attr('tabindex', '0').addClass('closed').next().hide();
        });

        //ADD CLICK EVENT TO SHOW/HIDE CONTENT BELOW HEADERS
        $(".module-agenda-sheet-item-clickable-container").on('click', function (event) {
            event.preventDefault();
            $(this).toggleClass('closed').next().slideToggle('fast');
        });

        $(".module-agenda-accordion-content").each(function () {

            var currentAgenda = this;
            //$(".js-module-agenda-sheet-button",this).prependTo(this);
            $(".js-module-agenda-sheet-button", $(this)).each(function () {

                $(this).appendTo($(".js-module-agenda-button-container", currentAgenda));

                var sheetId = this.id.replace("-button", "");

                $(this).on('click', function (event) {
                    event.preventDefault();

                    //ONLY CLICK WHEN CHANGING SHEET
                    var sheetElm = $('#' + sheetId);
                    if (sheetElm.is(':visible')) return;

                    $('.module-agenda-sheet', currentAgenda).hide();
                    sheetElm.slideDown('fast');
                    $(".btn-default", currentAgenda).removeClass('btn-default').addClass('btn-outline');
                    $(this).removeClass('btn-outline').addClass('btn-default');
                });
            });

            $(".module-agenda-sheet:not(:first)", currentAgenda).hide();
            $(".js-module-agenda-sheet-button:first", currentAgenda).addClass('btn-default').removeClass('btn-outline');

        });

        //HANDLE KEYPRESS ON COLLAPSIBLE HEADERS
        $('.module-agenda-sheet-item-clickable-container').keypress(function (event) {
            if (event.which == 13 || event.which == 32) {
                event.preventDefault();
                this.click();
            }
        });

        //HANDLE KEYPRESS ON BUTTONS
        $('.js-module-agenda-sheet-button').keypress(function (event) {
            if (event.which == 13 || event.which == 32) {
                event.preventDefault();
                this.click();
            }
        });

        //SHOW AFTER TRANSFORMATION
        collapsibleContentComponent.show();

    }
});